$('.home-banner .owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:true,
    items:1,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplaySpeed: 1000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
});

$('.explore-craft .owl-carousel, .handmade-fav .owl-carousel').owlCarousel({
    loop:true,
    margin:20,
    nav:false,
    dots:true,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplaySpeed: 1000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    responsive:{
        0:{items:1},
        576:{items:2},
        1200:{items:3},
    }
});


$(document).ready(function () {
    // 1. Initialize Outer Slider
    var slider1 = $('.video-slider');
    if (slider1.length) {
        slider1.owlCarousel({
            loop: true,
            margin: 20,
            nav: false,
            dots: true,
            autoplay: false,
            responsive: {
                0: { items: 1 },
                576: { items: 2 },
                768:{items: 3},
                992: { items: 4 },
                1400: { items: 5 }
            }
        });
    }

    var $modal = $('#exampleModal');
    var $slider2 = $('.video-slider2');
    var targetSlideIndex = 0;

    // Helper: Initialize or get Owl Carousel for Modal
    function initOrGetModalSlider() {
        if (!$slider2.hasClass('owl-loaded')) {
            $slider2.owlCarousel({
                loop: true,
                center: true,
                margin: 20,
                items: 1,
                nav: true,
                navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
                dots: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
                responsive: {
                    0: { nav: false, dots: true },
                    992: { nav: true, dots: false }
                }
            });
        }
        return $slider2;
    }

    // 2. Click Video Trigger: Capture exact relative index
    slider1.on('click', '.video-card-trigger, .owl-item', function () {
        var owl = slider1.data('owl.carousel');
        var $clickedOwlItem = $(this).closest('.owl-item');
        if (owl && $clickedOwlItem.length) {
            targetSlideIndex = owl.relative($clickedOwlItem.index());
        }
    });

    // 3. Modal Finished Opening: Recalculate layout & jump instantly
    $modal.on('shown.bs.modal', function () {
        initOrGetModalSlider();

        // Refresh dimensions now that modal is 100% visible
        $slider2.trigger('refresh.owl.carousel');
        $slider2.trigger('to.owl.carousel', [targetSlideIndex, 0, true]);

        // Sync active slide contents
        syncActiveSlideData();
        setupReadMore();
        updateCartBadge();
        playActiveVideo();
    });

    // 4. Modal Closing: Pause videos to avoid audio leak & lag
    $modal.on('hide.bs.modal', function () {
        pauseAllVideos();
    });

    // 5. Modal Carousel Slide Change
    $(document).on('translated.owl.carousel', '.video-slider2', function () {
        syncActiveSlideData();
        setupReadMore();
        pauseAllVideos();
        playActiveVideo();
    });

    function syncActiveSlideData() {
        $('.video-slider2 .owl-item.active .item').each(function () {
            initBlockFromActiveTab($(this));
        });
    }

    function setupReadMore() {
        $('.read-more').remove();
        $('.video-slider2 .owl-item.active .para-small').each(function () {
            if (this.scrollHeight > 100) {
                $(this).after('<span class="read-more">Read More</span>');
            }
        });
    }

    function pauseAllVideos() {
        // Pause HTML5 Videos
        $modal.find('video').each(function () {
            this.pause();
        });
        // Pause YouTube Iframes
        $modal.find('iframe').each(function () {
            this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }

    function playActiveVideo() {
        var $activeItem = $('.video-slider2 .owl-item.active');
        var $activeVideo = $activeItem.find('video');
        if ($activeVideo.length) {
            $activeVideo[0].play().catch(function () {});
        }
        var $activeIframe = $activeItem.find('iframe');
        if ($activeIframe.length) {
            $activeIframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
    }

    function initBlockFromActiveTab($item) {
        var $activeTab = $item.find('.selected-tab .tab-img.active');
        if (!$activeTab.length) {
            $activeTab = $item.find('.selected-tab .tab-img').first();
            $activeTab.addClass('active border-dark');
        }

        var url         = $activeTab.data('url');
        var variantId   = $activeTab.data('variant-id');
        var isAvailable = $activeTab.data('available');
        var description = $activeTab.data('description');

        var $viewBtn = $item.find('.btn-view-product');
        if (url) $viewBtn.attr('href', url);

        var $cartBtn = $item.find('.btn-add-to-cart');
        if (variantId) {
            $cartBtn.attr('data-variant-id', variantId);
            if (isAvailable === true || isAvailable === 'true') {
                $cartBtn.prop('disabled', false).text('Add to cart');
            } else {
                $cartBtn.prop('disabled', true).text('Out of stock');
            }
        } else {
            $cartBtn.prop('disabled', true).text('Out of stock');
        }

        var $desc = $item.find('.js-description');
        if (description) $desc.html(description);
    }

    $(document).on('click', '.selected-tab .tab-img', function () {
        var $tab        = $(this);
        var url         = $tab.data('url');
        var variantId   = $tab.data('variant-id');
        var isAvailable = $tab.data('available');
        var description = $tab.data('description');
        var $item       = $tab.closest('.item');

        $item.find('.selected-tab .tab-img').removeClass('active border-dark');
        $tab.addClass('active border-dark');

        var targetPaneId = $tab.attr('data-bs-target');
        if (targetPaneId) {
            $item.find('.tab-pane').removeClass('show active');
            $item.find(targetPaneId).addClass('show active');
        }

        if (url) $item.find('.btn-view-product').attr('href', url);

        var $cartBtn = $item.find('.btn-add-to-cart');
        if (variantId) {
            $cartBtn.attr('data-variant-id', variantId);
            if (isAvailable === true || isAvailable === 'true') {
                $cartBtn.prop('disabled', false).text('Add to cart');
            } else {
                $cartBtn.prop('disabled', true).text('Out of stock');
            }
        }

        if (description) $item.find('.js-description').html(description);
    });

    function updateCartBadge() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
                var count = cart.item_count;

                // Update ALL .js-cart-count elements (modal + header)
                $('.js-cart-count').text(count);

                // Show/hide ALL .cart-count-bubble elements (modal + header)
                if (count > 0) {
                    $('.cart-count-bubble').show();
                } else {
                    $('.cart-count-bubble').hide();
                }

                // Remove injected bubble (no longer needed)
                $('.header-cart-bubble').remove();
            }
        });
    }

    $(document).on('click', '.btn-add-to-cart', function () {
        var $btn = $(this);
        var variantId = $btn.attr('data-variant-id');

        if (!variantId) {
            alert('Please select a product first.');
            return;
        }

        $btn.prop('disabled', true).html('<i class="fa-solid fa-spinner fa-spin me-1"></i> Adding…');

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: variantId, quantity: 1 },
            dataType: 'json',
            success: function () {
                $btn.text('Added ✓');

                // Update badge
                updateCartBadge();

                // Refresh cart drawer
                // Refresh cart drawer
// Refresh cart drawer
fetch('/?sections=cart-drawer')
    .then(function(res) { return res.json(); })
    .then(function(data) {
        if (data['cart-drawer']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data['cart-drawer'], 'text/html');

            // Update cart items
            var newItems = doc.querySelector('#CartDrawer-CartItems');
            var oldItems = document.querySelector('#CartDrawer-CartItems');
            if (newItems && oldItems) {
                oldItems.innerHTML = newItems.innerHTML;
            }

            // Update total price
            var newTotal = doc.querySelector('.totals__total-value');
            var oldTotal = document.querySelector('.totals__total-value');
            if (newTotal && oldTotal) {
                oldTotal.innerHTML = newTotal.innerHTML;
            }

            // Remove is-empty class from cart-drawer
            var cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl) {
                cartDrawerEl.classList.remove('is-empty');
            }

            // Hide empty message, show cart form
            var emptyContent = document.querySelector('.drawer__inner-empty');
            if (emptyContent) {
                emptyContent.style.display = 'none';
            }

            var cartForm = document.querySelector('#CartDrawer-Form');
            if (cartForm) {
                cartForm.style.display = 'block';
            }

            // Update footer total section
            var newFooter = doc.querySelector('.drawer__footer');
            var oldFooter = document.querySelector('.drawer__footer');
            if (newFooter && oldFooter) {
                oldFooter.innerHTML = newFooter.innerHTML;
            }

            // Open the drawer
            setTimeout(function() {
                if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
                    cartDrawerEl.open();
                }
            }, 100);
        }
    });

                setTimeout(function () {
                    $btn.prop('disabled', false).text('Add to cart');
                }, 2000);
            },
            error: function (xhr) {
                var msg = xhr.responseJSON && xhr.responseJSON.description
                    ? xhr.responseJSON.description
                    : 'Could not add to cart. Please try again.';
                alert(msg);
                $btn.prop('disabled', false).text('Add to cart');
            }
        });
    });

    $(document).on('click', '.btn-open-cart', function () {
        window.location.href = '/cart';
    });

    $(document).on('click', '.read-more', function () {
        $(this).prev('.para-small').toggleClass('open');
        $(this).text($(this).text() === 'Read More' ? 'Read Less' : 'Read More');
    });

    updateCartBadge();
});
// similar product carousel (re-inits after async product-recommendations content is injected)
function initSimilarProductCarousel() {
    $('.similar-product .owl-carousel:not(.owl-loaded)').each(function () {
        $(this).owlCarousel({
            loop:true,
            margin:20,
            nav:false,
            dots:true,
            autoplay: false,
            responsive:{
                0:{items:1},
                576:{items:2},
                992:{items:3},
                1200:{items:4},
            }
        });
    });
}
initSimilarProductCarousel();
document.querySelectorAll('.similar-product').forEach(function (container) {
    new MutationObserver(initSimilarProductCarousel).observe(container, { childList: true, subtree: true });
});

$('.feature-product .owl-carousel').owlCarousel({
    loop:false,
    margin:20,
    nav:false,
    dots:true,
    autoplay: false,
    responsive:{
        0:{items:1},
        320:{items:2},
        576:{items:3},
        768:{items:4},
    }
});

// responsive nav collapse
function toggleCollapse() {
    document.querySelectorAll(".navbar-nav [data-bs-target]").forEach(trigger => {
        const target = document.querySelector(trigger.dataset.bsTarget);
        if (!target) return;

        if (window.innerWidth >= 992) {
            trigger.removeAttribute("data-bs-toggle");
            target.classList.remove("collapse", "show");
        } else {
            trigger.setAttribute("data-bs-toggle", "collapse");
            target.classList.add("collapse");
        }
    });
}
toggleCollapse();
window.addEventListener("resize", toggleCollapse);

// product list view more
$(function () {
    $(".ul-list").each(function () {
        const $list = $(this),
            $items = $list.children("li").slice(1);

        if ($items.length <= 5) return;

        $items.slice(5).hide();
        $('<li class="view-more-li"><a href="#" class="view-more-btn mt-1"><i class="fa-solid fa-angle-down me-1"></i>View More</a></li>').appendTo($list);

        $list.on("click", ".view-more-btn", function (e) {
            e.preventDefault();

            const $btn = $(this),
                expanded = $btn.toggleClass("active").hasClass("active");

            $items.slice(5).slideToggle(expanded);
            $btn.html(
                `<i class="fa-solid fa-angle-${expanded ? "up" : "down"} me-1"></i>View ${expanded ? "Less" : "More"}`
            );
        });
    });
});

// main-header
function setHeaderHeight() {
    document.body.style.paddingTop =
        document.querySelector(".main-header").offsetHeight + "px";
    document.documentElement.style.visibility = "visible";
}
setHeaderHeight();
window.addEventListener("load", setHeaderHeight);
window.addEventListener("resize", setHeaderHeight);

/* Product Detail Interactive Features */
$(function () {
	// 1. Size carousel (re-inits after product-info re-renders the variant panel)
	function initSizeCarousel() {
		$(".size-carousel-wrapper .owl-carousel").each(function () {
			$(this).owlCarousel({
				loop: false,
				margin: 0,
                autoWidth: true,
				nav: true,
				navText: [
					'<i class="fa-solid fa-chevron-left"></i>',
					'<i class="fa-solid fa-chevron-right"></i>'
				],
				dots: false,
				slideBy: 1,
				responsive: {
					0: { items: 3},
					480: { items: 3},
					768: { items: 4},
					1200: { items: 5},
				}
			});
		});
	}
	initSizeCarousel();
	document.querySelectorAll('.product-detail').forEach(function (container) {
		new MutationObserver(initSizeCarousel).observe(container, { childList: true, subtree: true });
	});

	// 2. Size & Color selection is handled by the variant-selects radios:
	//    checked state styling comes from CSS (input:checked + .size-box/.color-box)
	//    and product-info.js re-renders the panel after every change.

	// 3. BUY NOW: add current variant to cart, then go to checkout
	$(document).on('click', '.buy-now-btn', function () {
		var $btn = $(this);
		if ($btn.hasClass('loading')) return;

		var $form = $btn.closest('product-info').find('form[id^="product-form-"]').first();
		var variantId = $form.find('input[name="id"]').val();
		var quantity = parseInt($form.find('input[name="quantity"]').val(), 10) || 1;

		if (!variantId) {
			alert('Please select a product first.');
			return;
		}

		var originalHtml = $btn.html();
		$btn.addClass('loading').prop('disabled', true).html('<i class="fa-solid fa-spinner fa-spin me-1"></i> Redirecting…');

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: { id: variantId, quantity: quantity },
			dataType: 'json',
			success: function () {
				updateCartBadge();
				window.location.href = '/checkout';
			},
			error: function (xhr) {
				var msg = xhr.responseJSON && xhr.responseJSON.description
					? xhr.responseJSON.description
					: 'Could not add to cart. Please try again.';
				alert(msg);
				$btn.removeClass('loading').prop('disabled', false).html(originalHtml);
			}
		});
	});

	// 5. Quantity Plus/Minus buttons
	$(document).on('click', '[data-quantity-minus], [data-quantity-plus]', function () {
		var $box  = $(this).closest('.quantity-box');
		var $num  = $box.find('.quantity-num');
		var $input = $box.find('input[name="quantity"]');
		var val   = parseInt($num.text(), 10) || 1;
		var min   = parseInt($input.attr('min'), 10) || 1;
		var max   = $input.attr('max') ? parseInt($input.attr('max'), 10) : null;
		var next  = val + ($(this).is('[data-quantity-minus]') ? -1 : 1);

		if (next < min) next = min;
		if (max !== null && next > max) next = max;

		$num.text(next);
		$input.val(next);
	});

	// 6. Copy Coupon Code
	$(".copy-coupon-btn").on("click", function () {
		var code =
			$(this).data("code") ||
			$(this).closest(".offer-item").find(".coupon-code-badge").text().trim();
		if (code) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(code);
			}
			var $btn = $(this);
			var origText = $btn.text();
			$btn.text("Copied!");
			setTimeout(function () {
				$btn.text(origText);
			}, 2000);
		}
	});

/* product detail slider */
$(function () {
    $('.pd-slide-panel .owl-carousel').each(function () {
        const owl = $(this),
            panel = owl.closest('.pd-slide-panel'),
            dots = panel.find('.owl-dots');

        owl.owlCarousel({
            items: 1,
            loop: true,
            margin: 8,
            dots: false,
            nav: true,
            navText: [
                '<i class="fa-solid fa-chevron-left"></i>',
                '<i class="fa-solid fa-chevron-right"></i>'
            ],
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            smartSpeed: 1000
        });

        dots.before('<button class="dot-prev"><i class="fa-solid fa-chevron-left"></i></button>');
        dots.after('<button class="dot-next"><i class="fa-solid fa-chevron-right"></i></button>');

        const check = () => {
            const show = dots[0].scrollWidth > dots[0].clientWidth;
            panel.find('.dot-prev,.dot-next').toggle(show);
        };

        panel.on('click', '.dot-prev,.dot-next', function () {
            const dotWidth = dots.find('.owl-dot').outerWidth(true) || 100;
 
            dots[0].scrollBy({
                left: $(this).hasClass('dot-next') ? dotWidth : -dotWidth,
                behavior: 'smooth'
            });
        });

        dots.on('click', '.owl-dot', function () {
            owl.trigger('to.owl.carousel', [$(this).index(), 1000]);
        });

        owl.on('changed.owl.carousel', function (e) {
            const i = ((e.item.index - e.relatedTarget._clones.length / 2) % e.item.count + e.item.count) % e.item.count,
                dot = dots.find('.owl-dot').eq(i);

            dots.find('.owl-dot').removeClass('active');
            dot.addClass('active');

            dots.stop().animate({
                scrollLeft: dot.position().left + dots[0].scrollLeft -
                    dots.width() / 2 + dot.outerWidth() / 2
            }, 400);
        });

        $(window).on('resize', () => setTimeout(check, 100));
        check();
    });
});
/* product detail slider */
	
});

//Artisan Voices (About Us)
$('.their-words .owl-carousel').owlCarousel({
    loop:true,
    margin:5,
    nav:false,
    dots:true,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplaySpeed: 1000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    responsive:{
        0:{items:1},
        768:{items:2},
        1200:{items:3},
    }
});